/** Screen-space thresholds keep click-versus-drag consistent at every zoom. */
export const dragThreshold = (pointerType: string): number => pointerType === "touch" ? 11 : 5;

export function passedDragThreshold(
  startX: number,
  startY: number,
  clientX: number,
  clientY: number,
  threshold: number,
): boolean {
  return Math.hypot(clientX - startX, clientY - startY) >= threshold;
}
